const getTokenMixin = {
  methods: {
    toUserManager (id) {
      let handle = res => {
        const href = window.location.href
        if (href.indexOf('admin') > -1 && href.indexOf('test') === -1) {
          window.open(`https://txmpartner.zidouchat.com/#/admin-login?token=${res.data.content.token}`)
        } else {
          window.open(`http://partnertest.tuanxmi.com/#/admin-login?token=${res.data.content.token}`)
        }
      }
      this.__axios(this.getDomain() + 'bmclient/get_user_token', { client_id: id }, handle)
    },
    toQiyeManager (id) {
      let handle = res => {
        const href = window.location.href
        if (href.indexOf('admin') > -1 && href.indexOf('test') === -1) {
          window.open(`http://qiye.tuanxmi.com/#/admin-login?token=${res.data.content.token}`)
        } else {
          window.open(`http://qiyetest.tuanxmi.com/#/admin-login?token=${res.data.content.token}`)
        }
      }
      this.__axios(this.getDomain() + 'bmcompany/get_user_token', { t_company_id: id }, handle)
    }
  }
}

export default getTokenMixin
